import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { AppSettings } from '../app.settings';
import { ToastrService } from 'ngx-toastr';
import { Response } from '../models/response.model';
import { TimeZone } from '../models/time-zone.model';
import { Country } from '../models/country.model';
import {API_URL} from '../constants/api-urls';
import {Features} from '../interfaces/features';
import { FedInfoFeature } from '../interfaces/fed-info-feature';
import { FEDINFO_FEATURE_INIT_VALUES } from '../constants/fed-info-feature-init-values';
import { FEDINFO_FEATURE_LABEL } from '../constants/fed-info-feture-label';
import { AddressBookFeatures } from '../interfaces/address-book-features';
import { ADDRESS_BOOK_FEATURES } from '../constants/addres-book-features-labels';
import { ADDRESS_BOOK_INITIAL_VALUES } from '../constants/address-book-feature-initial-values';

// feature flags  received from config api
const SHOW_BILLING_INFO = 'SHOW_BILLING_INFO';
const USER_GUIDES  = 'USER_GUIDES';
const LOGO_URL = 'LOGO_URL';
const CLIENT_NAME = 'CLIENT_NAME';
const CLIENT_LABEL = 'CLIENT_LABEL';
const SHOW_WBS = 'SHOW_WBS';
const ORDER_WINDOW_LABEL = 'ORDER_WINDOW_LABEL';
const ON_DEMAND_LABEL = 'ON_DEMAND_LABEL';
const SHOW_DELIVERY_COMMENTS = 'SHOW_DELIVERY_COMMENTS';
const SHOW_ORDER_NOTES = 'SHOW_ORDER_NOTES';
const SHOW_PLANNING_COMMENTS = 'SHOW_PLANNING_COMMENTS';
const PRODUCT_CODE_LABEL = 'PRODUCT_CODE_LABEL';
const LIST_ORDERING = 'LIST_ORDERING';
const INTERNAL_ORDER = 'INTERNAL_ORDER';
const FAVICON_URL = 'FAVICON';
const PLANNINGCOMMENTS_LABEL = 'PLANNINGCOMMENTS_LABEL';
const SHOW_REFINER_SURVEY = 'SHOW_REFINER_SURVEY';

const initialFeatures: Features = {
    showBillingInfo: false,
    userGuides: [],
    logoUrl: '',
    clientName: '',
    clientLabel: '',
    showWBS: false,
    orderWindowLabel: 'Order Window',
    onDemandLabel: 'Quick Buy',
    showDeliveryComments: false,
    showOrderNotes: false,
    showPlanningComments: false,
    planningCommentsLabel: '',
    productCodeLabel: 'Product Code',
    showFavorites: true,
    productListViewEnabled: false,
    showInternalOrderCodes: false,
    favicon_url: '',
    showRefinerSurvey: true,
}

const initFedInfoFeatures: FedInfoFeature =  FEDINFO_FEATURE_INIT_VALUES;
const initAddressBookFeatures = ADDRESS_BOOK_INITIAL_VALUES;

@Injectable()
export class ConfigService extends BaseService {

    public timezones: Array<TimeZone>;
    public countries: Country[] = [];

    public isCredCardPaymentActive = false;
    public isSingleCreditCardOnly =  false;

    private _features: Features;
    private _fedInfoFeature: FedInfoFeature;
    private _addressBookFeature: AddressBookFeatures;

    constructor(
        protected http: HttpClient,
        protected appSettings: AppSettings,
        protected toastr: ToastrService,
    ) {
        super('/config', http, appSettings, toastr);
        this._features =  initialFeatures;
        this._fedInfoFeature = initFedInfoFeatures;

        this._addressBookFeature = initAddressBookFeatures;
    }

//     getNavItems(): Observable<NavItem[]> {
//         // const eTag: string = this.cache.getETag('navItems');
//         // const httpOptions: Object = {headers: new HttpHeaders({'If-Match': eTag})};
//         //
//         // if (this.tmpCache.has('navItems')) {
//         //     const result = this.cache.getItems('navItems');
//         //     _.each(result, (item, i) => {
//         //         result[i] = new NavItem(item);
//         //     });
//         //     return of(result);
//         // }
//
//         return this.http.get<Response>(this.apiURL + '/navigation')
//             .pipe(
//                 map(response => {
//                     const result = response.data;
//
//                     // if (result.length === 0 && response.eTag === eTag) {
//                     //     result = this.cache.getItems('navItems');
//                     // }
//
//                     _.each(result, (item, i) => {
//                         result[i] = new NavItem(item);
//                     });
//
//                     // if (response.eTag != eTag) {
//                     //     this.cache.deleteItems('navItems');
//                     //     this.cache.setItems('navItems', result);
//                     //     this.cache.setETag('navItems', response.eTag);
//                     // }
//
// //                    this.tmpCache.set('navItems', true);
//
//                     return result;
//                 }),
//                 catchError(this.handleError('ConfigService::getNavItems', []))
//             );
//     }

//     getTimeZones(): Observable<any[]> {
//         // const eTag: string = this.cache.getETag('timezones');
//         // const httpOptions: Object = {headers: new HttpHeaders({'If-Match': eTag})};
//         //
//         // if (this.tmpCache.has('timezones')) {
//         //     const result = this.cache.getItems('timezones');
//         //     _.each(result, (item, i) => {
//         //         result[i] = new TimeZone(item);
//         //     });
//         //     this.timezones = result;
//         //     return of(result);
//         // }
//
//         return this.http.get<Response>(this.apiURL + '/timezones')
//             .pipe(
//                 map(response => {
//                     const result = response.data;
//
//                     // if (result.length === 0 && response.eTag == eTag) {
//                     //     result = this.cache.getItems('timezones');
//                     // }
//
//                     _.each(result, (item, i) => {
//                         result[i] = new TimeZone(item);
//                     });
//
//                     // if (response.eTag != eTag) {
//                     //     this.cache.deleteItems('timezones');
//                     //     this.cache.setItems('timezones', result);
//                     //     this.cache.setETag('timezones', response.eTag);
//                     // }
//
//                     this.timezones = result;
// //                    this.tmpCache.set('timezones', true);
//
//                     return this.timezones;
//                 }),
//                 catchError(this.handleError('ConfigService::getTimeZones', []))
//             );
//     }

    getCountries(): Observable<Country[]> {
        if (this.countries.length) {
            return of(this.countries);
        }

        const url  = `${API_URL}/config/countries`;
        return this.http.get<Response>(url)
            .pipe(
                map(response => {
                    const result = response.data;

                    this.countries = result.map(item => new Country(item));
                    return this.countries;
                }),
                catchError(this.handleError('ConfigService::getCountries', []))
            );
    }

    public getCountryLabel(countryCode: string): Observable<string> {
        return this.getCountries().pipe(
            map(countries => {
                const country = countries.find(c => c.isoCode === countryCode);
                return country ? country.label : '';
            })
        );
    }

    getShippingMethods(): Observable<{label: string}[]> {
        // tmp, to be replaced by a endpoint
        const items = [
            {label: 'GROUND'},
            {label: 'TWO_DAY'},
            {label: 'NEXT_DAY'},
        ];

        return of(items);
    }

    getConfigData(key: string): Observable<unknown[]> {
        return this.http.get<Response>(this.apiURL + '/data/' + key)
            .pipe(
                map(response => {
                    return response.data;
                }),
                catchError(this.handleError('ConfigService::getConfigData', []))
            );
    }

    // retrieve credit card settings (turn off/on)
    public fetchCreditCardSettings(): Observable<boolean> {
        const url = `${this.apiURL}/credit-cards`;
        this.isCredCardPaymentActive = false;

        return this.http.get<Response>(url).pipe(
            map (response => {
                if (response.data) {
                    this.isCredCardPaymentActive = response.data.enabled;
                    return this.isCredCardPaymentActive;
                } else {
                    return false;
                }
            }),
            catchError(this.handleError('ConfigService::credit-card', false))
        );
    }

    protected handleError<T>(operation = 'operation', result?: T) {
        return (error: { message?: string }): Observable<T> => {
            console.log(`${operation} failed: ${error.message}`);

            return of(result as T);
        };
    }


    public getFeatureBrands(): Observable<unknown[]> {
        return this.getConfigData('brands');
    }

    public get showBillingInfo(): boolean {
        return this.features?.showBillingInfo === true
    }

    public get showIOAndWBS(): boolean {
        return this._fedInfoFeature?.showWbs === true || this._fedInfoFeature?.showInternalOrder === true;
    }

    public fetchFeatures(userId: number): Observable<boolean> {
        const url = `${API_URL}/config/features/with-visibility`;

        return this.http.post(url, {user_id: userId}).pipe(
            map((response) => {
                    const getFeatureValue = (key: string) => response?.[key]?.value || '';

                    const isVisible = (key: string) => Number(response?.[key]?.visibility) === 1;

                    const isRequired = (key: string) => Number(response?.[key]?.required) === 1;
                    if (response) {
                        const respUserGuide = response?.[USER_GUIDES];
                        const userGuides = typeof respUserGuide === 'string' ? JSON.parse(respUserGuide) : (respUserGuide || []);
                        // '/assets/img/logos/diageo-logo.png' : '/assets/img/logos/remy_logo.jpg'
                        this._features =  {
                            showBillingInfo: isVisible(SHOW_BILLING_INFO),
                            userGuides,
                            logoUrl: getFeatureValue(LOGO_URL),
                            clientName: getFeatureValue(CLIENT_NAME),
                            clientLabel: getFeatureValue(CLIENT_LABEL),
                            showWBS: isVisible(SHOW_BILLING_INFO) && isVisible(SHOW_WBS),
                            orderWindowLabel: getFeatureValue(ORDER_WINDOW_LABEL),
                            onDemandLabel: getFeatureValue(ON_DEMAND_LABEL),
                            showOrderNotes: isVisible(SHOW_ORDER_NOTES),
                            showPlanningComments: isVisible(SHOW_PLANNING_COMMENTS),
                            showDeliveryComments: isVisible(SHOW_DELIVERY_COMMENTS),
                            productCodeLabel: getFeatureValue(PRODUCT_CODE_LABEL),
                            showFavorites: true,
                            productListViewEnabled: isVisible(LIST_ORDERING),
                            showInternalOrderCodes: isVisible(INTERNAL_ORDER),
                            favicon_url: getFeatureValue(FAVICON_URL),
                            planningCommentsLabel: getFeatureValue(PLANNINGCOMMENTS_LABEL),
                            showRefinerSurvey: response?.[SHOW_REFINER_SURVEY] !== undefined ? isVisible(SHOW_REFINER_SURVEY) : true,
                        }
                        
                    this._addressBookFeature = {
                        companyNameLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.COMPANY_NAME_LABEL) || initAddressBookFeatures.companyNameLabel,
                        streetAddressLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.STREET_ADDRESS_LABEL) || initAddressBookFeatures.streetAddressLabel,
                        suiteUnitLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.SUITE_UNIT_LABEL) || initAddressBookFeatures.suiteUnitLabel,
                        suiteRequired: isRequired(ADDRESS_BOOK_FEATURES.SUITE_UNIT_LABEL) || initAddressBookFeatures.suiteRequired,
                        cityLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.CITY_LABEL) || initAddressBookFeatures.cityLabel,
                        cityRequired: isRequired(ADDRESS_BOOK_FEATURES.CITY_LABEL) || initAddressBookFeatures.cityRequired,
                        stateProvinceLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.STATE_PROVINCE_LABEL) || initAddressBookFeatures.stateProvinceLabel,
                        stateRequired: isRequired(ADDRESS_BOOK_FEATURES.STATE_PROVINCE_LABEL) || initAddressBookFeatures.stateRequired,
                        zipPostalCodeLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.ZIP_POSTAL_CODE_LABEL) || initAddressBookFeatures.zipPostalCodeLabel,
                        countryLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.COUNTRY_LABEL) || initAddressBookFeatures.countryLabel,
                        phoneNumberLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.PHONE_NUMBER_LABEL) || initAddressBookFeatures.phoneNumberLabel,
                        phoneNumberRequired: isRequired(ADDRESS_BOOK_FEATURES.PHONE_NUMBER_LABEL) || initAddressBookFeatures.phoneNumberRequired,
                        deliveryInstructionsLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.DELIVERY_INSTRUCTIONS_LABEL) || initAddressBookFeatures.deliveryInstructionsLabel,  
                        deliveryInstructionsRequired: isRequired(ADDRESS_BOOK_FEATURES.DELIVERY_INSTRUCTIONS_LABEL) || initAddressBookFeatures.deliveryInstructionsRequired,
                        showDeliveryInstructions: isVisible(ADDRESS_BOOK_FEATURES.DELIVERY_INSTRUCTIONS_LABEL),
                        mainContactEmailLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.MAIN_CONTACT_EMAIL_LABEL) || initAddressBookFeatures.mainContactEmailLabel,
                        mainContactEmailRequired: isRequired(ADDRESS_BOOK_FEATURES.MAIN_CONTACT_EMAIL_LABEL) || initAddressBookFeatures.mainContactEmailRequired,
                        showMainContactEmail: isVisible(ADDRESS_BOOK_FEATURES.MAIN_CONTACT_EMAIL_LABEL),
                        mainContactNameLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.MAIN_CONTACT_NAME_LABEL) || initAddressBookFeatures.mainContactNameLabel,
                        mainContactNameRequired: isRequired(ADDRESS_BOOK_FEATURES.MAIN_CONTACT_NAME_LABEL) || initAddressBookFeatures.mainContactNameRequired,
                        showMainContactName: isVisible(ADDRESS_BOOK_FEATURES.MAIN_CONTACT_NAME_LABEL),
                        additionalContactEmailLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.ADDITIONAL_EMAIL_LABEL) || initAddressBookFeatures.additionalContactEmailLabel,
                        additionalContactEmailRequired: isRequired(ADDRESS_BOOK_FEATURES.ADDITIONAL_EMAIL_LABEL) || initAddressBookFeatures.additionalContactEmailRequired,
                        showAdditionalContactEmail: isVisible(ADDRESS_BOOK_FEATURES.ADDITIONAL_EMAIL_LABEL),
                        additionalContactNameLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.ADDITIONAL_NAME_LABEL) || initAddressBookFeatures.additionalContactNameLabel,
                        additionalContactNameRequired: isRequired(ADDRESS_BOOK_FEATURES.ADDITIONAL_NAME_LABEL) || initAddressBookFeatures.additionalContactNameRequired,
                        showAdditionalContactName: isVisible(ADDRESS_BOOK_FEATURES.ADDITIONAL_NAME_LABEL),
                        clientAddressIdLabel: getFeatureValue(ADDRESS_BOOK_FEATURES.CLIENT_ADDRESS_ID_LABEL) || initAddressBookFeatures.clientAddressIdLabel,
                        showClientAddressId: isVisible(ADDRESS_BOOK_FEATURES.CLIENT_ADDRESS_ID_LABEL),
                        clientAddressIdRequired: isRequired(ADDRESS_BOOK_FEATURES.CLIENT_ADDRESS_ID_LABEL) || initAddressBookFeatures.clientAddressIdRequired,
                    }
                    this._fedInfoFeature = {
                            showInternalOrder: isVisible(FEDINFO_FEATURE_LABEL.INTERNAL_ORDER_LABEL),
                            internalOrderLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.INTERNAL_ORDER_LABEL) || 'Internal Order',
                            billingCodeDropdown: getFeatureValue(FEDINFO_FEATURE_LABEL.BILLING_CODE_DROPDOWN) || 'Order Code',
                            showBillingCodeDropdown: isVisible(FEDINFO_FEATURE_LABEL.BILLING_CODE_DROPDOWN),
                            showWbs: isVisible(FEDINFO_FEATURE_LABEL.WBS_LABEL),
                            wbsLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.WBS_LABEL) || '',
                            showDeliveryComments: isVisible(FEDINFO_FEATURE_LABEL.DELIVERY_COMMENTS_LABEL),
                            deliveryCommentslabel: getFeatureValue(FEDINFO_FEATURE_LABEL.DELIVERY_COMMENTS_LABEL) ||'',
                            showOrderComments: isVisible(FEDINFO_FEATURE_LABEL.ORDER_COMMENTS_LABEL),
                            orderCommentsLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.ORDER_COMMENTS_LABEL) ||'',
                            showOrderNotes: isVisible(FEDINFO_FEATURE_LABEL.ORDER_NOTES_LABEL),
                            orderNotesLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.ORDER_NOTES_LABEL) ||'',
                            showProductCode: isVisible(FEDINFO_FEATURE_LABEL.PRODUCT_CODE_LABEL),
                            productCodeLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.PRODUCT_CODE_LABEL) ||'',
                            showOnDemand: isVisible(FEDINFO_FEATURE_LABEL.ON_DEMAND_LABEL),
                            onDemandLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.ON_DEMAND_LABEL) ||'',
                            showOnDemandOrders: isVisible(FEDINFO_FEATURE_LABEL.ON_DEMAND_ORDERS_LABEL),
                            onDemandOrdersLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.ON_DEMAND_ORDERS_LABEL) ||'',
                            showOrderWindow: isVisible(FEDINFO_FEATURE_LABEL.ORDER_WINDOW_LABEL),
                            orderWindowLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.ORDER_WINDOW_LABEL) ||'',
                            showOrderWindowOrders: isVisible(FEDINFO_FEATURE_LABEL.ORDER_WINDOW_ORDERS_LABEL),
                            orderWindowOrdersLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.ORDER_WINDOW_ORDERS_LABEL) ||'',
                            showPlaningComments: isVisible(FEDINFO_FEATURE_LABEL.PLANNING_COMMENTS_LABEL),
                            planningCommentsLabel: getFeatureValue(FEDINFO_FEATURE_LABEL.PLANNING_COMMENTS_LABEL) ||''
                        }
                    } else {
                        this._features = initialFeatures;
                        this._fedInfoFeature = initFedInfoFeatures;
                        this._addressBookFeature = initAddressBookFeatures;
                    }
                    return true;
                }
            ), catchError(this.handleError('ConfigService::fetchFeatures', false)));
    }



    get isPresetAddressesAllowed(): boolean {
        // for future use
        return true;
    }


    get features(): Features {
        return this._features;
    }

    get fedInfoFeature(): FedInfoFeature {
        return this._fedInfoFeature;
    }
    get addressBookFeatures(): AddressBookFeatures {
        return this._addressBookFeature;
    }

    get wbsValidationOptions() {
        return {
            showInternalOrderCodes: this._features?.showInternalOrderCodes || this._fedInfoFeature?.showInternalOrder,
            showWBS: this._features?.showWBS || this._fedInfoFeature?.showWbs,
            showBillingCodeDropdown: this._fedInfoFeature?.showBillingCodeDropdown,
            billingCodeLabel: this.getInternalOrderLabel()
        };
    }

    get showRefinerSurvey(): boolean {
        return this._features?.showRefinerSurvey === true;
    }

    public getInternalOrderLabel(isWBSDefined?: boolean, isNotRealOrder = false): string {
        const fedInfoFeature = this._fedInfoFeature;

        if (fedInfoFeature.showBillingCodeDropdown) {
            return fedInfoFeature.billingCodeDropdown;
        }

        if (fedInfoFeature.showWbs && !fedInfoFeature.showInternalOrder) {
            return fedInfoFeature.wbsLabel || 'WBS';
        }

        if (fedInfoFeature.showInternalOrder && !fedInfoFeature.showWbs) {
            return fedInfoFeature.internalOrderLabel || 'Internal Order';
        }

        if (fedInfoFeature.showWbs && fedInfoFeature.showInternalOrder && isNotRealOrder) {
            return 'Order Code';
        }

        return isWBSDefined ? (fedInfoFeature.wbsLabel || 'WBS') : (fedInfoFeature.internalOrderLabel || 'Internal Order');
    }
    
}
